import { render } from "./CardTags.vue?vue&type=template&id=642bc9b4&ts=true"
import script from "./CardTags.vue?vue&type=script&lang=ts"
export * from "./CardTags.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__